module.exports = __webpack_public_path__ + "static/media/how_work_4.2bf0365d.svg";